import { all } from 'redux-saga/effects';

import listaCep from './endereco/lista-cep/saga';
import pais from './endereco/pais/saga';
import consultarDigitais from './consultarDigitais/saga';
import consultarDigitaisIIRGD from './consultarDigitaisIIRGD/saga';
import confrontarDigitais from './confrontarDigitais/saga';
import confrontarDigitaisIIRGD from './confrontarDigitaisIIRGD/saga';
import confrontarDigitaisCnh from './confrontarDigitaisCnh/saga';
import enderecoIp from './enderecoIp/saga';
import consultaCidadesUF from './consultaCidadesUF/saga';
import consultarFotosRg from './consultarFotosRg/saga';
import enderecos from './enderecos/saga';
import baixarArquivos from './arquivos/baixarArquivos/saga';
import bcadastro from './bcadastro/saga';
import eventosPPTContabilizacao from './eventosPPT/contabilizacao/saga';
import uploadArquivo from './uploadArquivo/saga';

export default all([
	listaCep,
	pais,
	consultarDigitais,
	consultarDigitaisIIRGD,
	confrontarDigitais,
	confrontarDigitaisIIRGD,
	confrontarDigitaisCnh,
	enderecoIp,
	consultaCidadesUF,
	consultarFotosRg,
	enderecos,
	baixarArquivos,
	bcadastro,
	eventosPPTContabilizacao,
	uploadArquivo,
]);
